import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';

const D3DrawThresholdOverlay = {
  [OperatorTypes.GREATER_THAN]: (svg, threshold, height, xPosition,
    // eslint-disable-next-line no-unused-vars
    overlayWidth, marginBottom, yAxis) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    const yPosition = yAxis(max);
    const rectHeight = threshold.value > min
      ? yAxis(threshold.value) - yPosition : yAxis(min) - yPosition;
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, yPosition, overlayWidth, rectHeight);
  },
  [OperatorTypes.EQUAL_TO_BOOLEAN]: (svg, threshold, height, xPosition,
    overlayWidth, marginBottom, yAxis,
    options = { trueDisplayValue: 'True', falseDisplayValue: 'False' }) => {
    const adjust = yAxis.bandwidth() / 2;
    const yPosition = yAxis((threshold.value >= 1 ? options.trueDisplayValue
      : options.falseDisplayValue)) + adjust - 10;
    const rectHeight = 20;
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, yPosition, overlayWidth, rectHeight);
  },
  [OperatorTypes.LESS_THAN]: (svg, threshold, height, xPosition,
    overlayWidth, marginBottom, yAxis,
    // eslint-disable-next-line no-unused-vars
    options = {}) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    if (threshold.value < min) { // Means it is off the chart
      return;
    }
    const yPosition = yAxis(threshold.value > max ? max : threshold.value);
    const rectHeight = yAxis(min) - yPosition;
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, yPosition, overlayWidth, rectHeight);
  },
  [OperatorTypes.EQUAL_TO_VALUE]: (svg, threshold, height,
    // eslint-disable-next-line no-unused-vars
    xPosition, overlayWidth, marginBottom, yAxis, options = {}) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    if (threshold.value > max || threshold.value < min) {
      return;
    }
    const yPosition = yAxis(threshold.value + 2.5);
    const rectHeight = 5;
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, yPosition, overlayWidth, rectHeight);
  },
  [OperatorTypes.NOT_EQUAL_TO]: (svg, threshold, height,
    // eslint-disable-next-line no-unused-vars
    xPosition, overlayWidth, marginBottom, yAxis, options = {}) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    const aboveY = yAxis(max);
    const aboveHeight = yAxis(threshold.value + 0.5) - yAxis(max);
    if (threshold.value < min || threshold.value > max) { // If value below chart
      D3DrawThresholdOverlay.drawRectangle(
        svg, xPosition, aboveY, overlayWidth, (yAxis(min) - yAxis(max)),
      );
      return;
    }
    const bottomY = yAxis(threshold.value - 0.5);
    const bottomHeight = height - yAxis(threshold.value - 0.5) - marginBottom;
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, bottomY, overlayWidth, bottomHeight);
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, aboveY, overlayWidth, aboveHeight);
  },
  [OperatorTypes.BETWEEN]: (svg, threshold, height,
    // eslint-disable-next-line no-unused-vars
    xPosition, overlayWidth, marginBottom, yAxis, options = {}) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    const lowerBound = Math.min(threshold.value, threshold.value2);
    let upperBound = Math.max(threshold.value, threshold.value2);
    upperBound = upperBound > max + 5 ? max : upperBound;
    const yPosition = yAxis(upperBound);
    const rectHeight = yAxis(lowerBound > min ? lowerBound : min) - yAxis(upperBound);
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, yPosition, overlayWidth, rectHeight);
  },
  [OperatorTypes.NOT_BETWEEN]: (svg, threshold, height,
    // eslint-disable-next-line no-unused-vars
    xPosition, overlayWidth, marginBottom, yAxis, options = {}) => {
    const max = yAxis.domain()[1];
    const min = yAxis.domain()[0];
    if (threshold.value > max) { // Means it is off the chart
      return;
    }
    const lowerBound = Math.min(threshold.value, threshold.value2);
    const upperBound = Math.max(threshold.value, threshold.value2);
    const aboveY = yAxis(max);
    const aboveHeight = yAxis(upperBound > min ? threshold.value : min) - yAxis(max);
    D3DrawThresholdOverlay.drawRectangle(svg, xPosition, aboveY, overlayWidth, aboveHeight);
    if (upperBound < min) {
      return;
    }
    if (lowerBound > min) {
      const bottomY = yAxis(lowerBound);
      const bottomHeight = height - yAxis(lowerBound) - marginBottom;
      D3DrawThresholdOverlay.drawRectangle(svg, xPosition, bottomY, overlayWidth, bottomHeight);
    }
  },
  drawRectangle: (svg, xPosition, yPosition, overlayWidth, rectHeight) => {
    svg
      .append('rect')
      .attr('x', xPosition)
      .attr('y', yPosition)
      .attr('width', overlayWidth)
      .attr('height', rectHeight)
      .attr('fill', 'red')
      .style('opacity', '0.25');
  },
};
export default D3DrawThresholdOverlay;
